import './app.css'
import Router from "./router/router"


export default function App() {

  return (
    <div className='App'>
<Router/>
    </div>
  )
}
